<app-form-element [control]="formControl" [id]="id" [label]="label" [required]="required" [twoColumns]="twoColumns">
  <p-multiSelect
    (onChange)="change()"
    [appendTo]="'body'"
    [formControl]="formControl"
    [id]="id"
    [options]="options"
    [placeholder]="'GLOBAL.CHOOSE' | translate"
    [style]="{ width: '100%' }"></p-multiSelect>
</app-form-element>
